/**
 * @generated SignedSource<<ee695fa8d1955f672a375d1fc07581b0>>
 * @relayHash 737450506e15e96d14963817488d5b84
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a596133b9a30c0a933f683ce3399c2d481a9817e83543138dfd63bcd765ac674

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a596133b9a30c0a933f683ce3399c2d481a9817e83543138dfd63bcd765ac674",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
